import UIkit from 'uikit';
import ControllerBase from './../../../../global/js/ControllerBase';

export default class ControllerNavbar extends ControllerBase {
	constructor(element: HTMLElement) {
		super(element);
	}
}
